import { render } from "./ModalSalesOrder.vue?vue&type=template&id=4cd83a12"
import script from "./ModalSalesOrder.vue?vue&type=script&lang=js"
export * from "./ModalSalesOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__